import find from "lodash/find";
import { useImportanceLabelMap } from "PFApp/hooks/use_importance_label_map";
import { Label } from "PFComponents/label";
import { MultiToggle } from "PFComponents/multi_toggle";
import { ReadOnlyField } from "PFComponents/read_only_field";
import { Typography } from "PFComponents/typography";
import { Importance } from "PFTypes";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type ImportanceToggleProps = {
  importance: Importance | null;
  canEdit?: boolean;
  onChange: (value: Importance) => void;
};

export const ImportanceToggle = ({ importance, canEdit, onChange }: ImportanceToggleProps) => {
  const { t } = useTranslation();
  const importanceLabelMap = useImportanceLabelMap();

  const importanceOptions = useMemo(
    () => [
      {
        id: Importance.Supporting,
        value: importanceLabelMap[Importance.Supporting]
      },
      {
        id: Importance.Essential,
        value: importanceLabelMap[Importance.Essential]
      },
      {
        id: Importance.Required,
        value: importanceLabelMap[Importance.Required]
      }
    ],
    [t]
  );

  return canEdit ? (
    <MultiToggle
      label={<Label text={t("customValueSidepanel.importance")} required />}
      options={importanceOptions}
      controlledValue={importance}
      onChange={onChange}
    />
  ) : (
    <ReadOnlyField
      label={t("customValueSidepanel.importance")}
      value={<Typography variant="bodyBold">{find(importanceOptions, ["id", importance])?.value}</Typography>}
    />
  );
};
